import React from 'react'
import 'firebase/performance'
import 'firebase/firestore'
import { Main, Header, Heading } from 'grommet'

import LoadUserID from '../Loading/LoadUserID'
import Properties from '../Properties/Properties'

const Home = (props) => {
  return (
    <Main>
      <Header background="brand" pad="medium">
        <Heading style={{ fontSize: '3rem', textAlign: 'center', width: '100%' }}>
          My properties
        </Heading>
      </Header>
      <LoadUserID>
        <Properties />
      </LoadUserID>
    </Main>
  )
}

export default Home
